'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("slick-carousel");
var Slick;
(function (Slick) {
    var MySlick = /** @class */ (function () {
        function MySlick() {
            window.addEventListener('load', function () {
                $('#bulletSlick').slick({
                    dots: true,
                    adaptiveHeight: true,
                });
            });
        }
        return MySlick;
    }());
    Slick.MySlick = MySlick;
})(Slick || (Slick = {}));
exports.default = Slick;
